export const SET_SCAN_CODE = 'SET_SCAN_CODE';
